module.exports = require("@swa-ui/core/src/RadioButton/RadioButton.module.scss");